/* eslint-disable max-len */
import Phaser from 'phaser';

import { gameBall, siteBall } from '../assets/ball';
import ring from '../assets/ring';
import logo from '../assets/logo-big.svg';

import config from '../config';

class LoadScene extends Phaser.Scene {
    constructor() {
        super('PreloadScene');
    }

    preload() {
        const dpr = config.resolution > 1 && config.resolution < 5 ? Math.floor(config.resolution) : (config.resolution >= 5 && 4) || 1;

        this.load.image('gameBall', gameBall[dpr]);
        this.load.image('siteBall', siteBall[dpr]);

        if (this.sys.game.isRenderGame) {
            this.load.image('ring', ring[dpr]);
            this.load.svg('logo', logo);
        }
    }

    create() {
        if (this.sys.game.isRenderGame) {
            this.scene.start('GameScene');
        } else {
            this.scene.start('SiteScene');
        }
    }
}

export default LoadScene;
